$('.slider_big').slick({
  prevArrow: false,
  nextArrow: false,
  dots: true,
  fade: true,
});
$('.slider-for').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  asNavFor: '.slider-nav',
  prevArrow: false,
  nextArrow: false,
  fade: true,
  infinite: true,
});
$('.slider-nav').slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  asNavFor: '.slider-for',
  dots: false,
  centerMode: true,
  focusOnSelect: true,
  true: true,
  // prevArrow: false,
  // nextArrow: false,
  infinite: true,
});

jQuery(function($){
  if($('.ef_scroll')) {
    $('.ef_scroll').simplemarquee({
      speed: 100,
      space: 0,
      cycles: Infinity,
      delayBetweenCycles: 0,
      handleHover: false,
    });
  }

  $('.collectionSubNavi a').on('click', function(e) {
      
    e.preventDefault();

    var $clicked = $(this);
    var $li = $clicked.parent();

    // 動作1: すでにactiveなら何もしない
    if ($li.hasClass('active')) return;

    // .collectionBlock を特定
    var $block = $clicked.closest('.collectionBlock');

    // 動作1: activeの切り替え
    $li.addClass('active').siblings().removeClass('active');

    // 動作2: data-subを取得して該当のアイテムのみ表示
    var subKey = $clicked.data('sub');
    console.log( subKey );

    $block.find('.arrivals_it').each(function() {
      var $item = $(this);
      if (subKey === 'all' || $item.data('sub') === subKey) {
        $item.show();
      } else {
        $item.hide();
      }
    });
  });
})